// import React, { useState } from "react";
// import { Button, CkTextEditor, FormFieldSet } from "../../../../../components";

// const Sequences = () => {
//   const [steps, setSteps] = useState([
//     { id: 1, variants: [1], }, // each step has variants
//   ]);

//   const addStep = () => {
//     if (steps.length < 5) {
//       setSteps([
//         ...steps,
//         { id: steps.length + 1, variants: [1] }, // new step starts with 1 variant
//       ]);
//     }
//   };

//   const removeStep = (stepId) => {
//     if (steps.length > 1) {
//       setSteps(steps.filter((step) => step.id !== stepId));
//     }
//   };

//   const addVariant = (stepId) => {
//     setSteps(
//       steps.map((step) =>
//         step.id === stepId && step.variants.length < 10
//           ? {
//               ...step,
//               variants: [
//                 ...step.variants,
//                 step.variants[step.variants.length - 1] + 1,
//               ],
//             }
//           : step
//       )
//     );
//   };

//   const onDeletevariant = (stepId, varient) => {
//     setSteps(
//       steps.map((step) =>
//         step.id === stepId
//           ? {
//               ...step,
//               variants: step.variants.filter((val) => val !== varient),
//             }
//           : step
//       )
//     );
//   };

//   return (
//     <div className="flex gap-5 mx-4 my-3 px-2 py-4 items-start">
//       <div className="w-fit">
//         {steps.map((step, index) => (
//           <div key={step.id} className="mb-4">
//             {index > 0 && (
//               <div className="mb-3">
//                 <FormFieldSet
//                   title="Send next message in days"
//                   placeholder="Send next message in days"
//                 />
//               </div>
//             )}

//             <div className="inner-section p-4 rounded flex flex-col gap-2">
//               <div className="border-b border-gray-300 flex justify-between items-center my-2">
//                 <p>Step {index + 1}</p>
//                 <Button
//                   type="icon"
//                   variant="text"
//                   icon={"delete"}
//                   size="sm"
//                   onClick={() => removeStep(step.id)}
//                 />
//               </div>

//               <div className="flex flex-col gap-2">
//                 {step.variants.map((variant, vIndex) => (
//                   <div
//                     className={`w-full border border-gray-300 flex justify-between items-center py-1 px-2 rounded
//                         bg-white hover:border-primary-600 focus-within:border-primary-600 focus-within:outline-none`}
//                   >
//                     <input
//                       className={`w-full bg- border-0 focus:outline-none "bg-neutral-200 text-gray-600"
//                           text-black bg-white`}
//                       placeholder="<Empty subject>"
//                       disabled:true
//                     />
//                     {vIndex!==0&& // mahee add  this line
//                     <Button
//                       type="icon"
//                       icon={"delete"}
//                       variant="text"
//                       color="black"
//                       onClick={() => onDeletevariant(step.id, variant)}
//                     />
//                     }

//                   </div>
//                 ))}
//               </div>

//               {step.variants.length < 10 && (
//                 <div className="grid grid-cols-2 my-2">
//                   <Button
//                     title={"Add Varient"}
//                     icon={"add"}
//                     size="sm"
//                     onClick={() => addVariant(step.id)}
//                   />
//                 </div>
//               )}
//             </div>

//             {index === steps.length - 1 && steps.length < 5 && (
//               <div className="grid grid-cols-1 gap-3 my-2">
//                 <Button
//                   title={"Add Step"}
//                   icon={"add"}
//                   variant="outlined"
//                   size="sm"
//                   onClick={addStep}
//                 />
//               </div>
//             )}
//           </div>
//         ))}
//       </div>

//       <div className="flex flex-col flex-1 gap-y-5">
//         <FormFieldSet noTitle value="Subject:"  />
//         <CkTextEditor />
//         <div className="flex justify-end">
//           <Button title={"Save"} icon={"stat_minus_1"} iconPosition="after" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Sequences;

import React, { useEffect, useState } from "react";
import {
  Button,
  CkTextEditor,
  FormFieldSet,
  showToast,
} from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { successCreateInstantlyCampaign } from "../../../../../redux/slices/compaigns/compaignsSlice";
import { useNavigate } from "react-router-dom";

const Sequences = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sub, setSub] = useState("");
  const [body, setBody] = useState("");
  const [steps, setSteps] = useState([
    {
      id: 1,
      type: "email",
      delay: 0,
      variants: [{ id: 1, subject: "", body: "", v_disabled: true }],
    }, // initial step with object variant
  ]);
   const createCampaigns =useSelector((state) => state.compaigns?.instantly?.createCampaigns) || {};
  const addStep = () => {
    if (steps.length < 5) {
      setSteps([
        ...steps,
        {
          id: steps.length + 1,
          variants: [{ id: 1, subject: "", body: "", v_disabled: true }],
          days: "",
        },
      ]);
      setSub("");
      setBody("");
    }
  };
  const handleDelayChange = (stepId, newDelay) => {
    setSteps((prevSteps) =>
      prevSteps.map((step) =>
        step.id === stepId ? { ...step, delay: newDelay } : step
      )
    );
  };
  const removeStep = (stepId) => {
    if (steps.length > 1) {
      setSteps(steps.filter((step) => step.id !== stepId));
    }
  };

  const addVariant = (stepId) => {
    setSteps(
      steps.map((step) =>
        step.id === stepId && step.variants.length < 10
          ? {
              ...step,
              variants: [
                ...step.variants,
                {
                  id: step.variants.length + 1,
                  subject: "",
                  body: "",
                  v_disabled: true,
                },
              ],
            }
          : step
      )
    );
    setSub("");
    setBody("");
  };

  const onDeleteVariant = (stepId, variantId) => {
    setSteps(
      steps.map((step) =>
        step.id === stepId
          ? {
              ...step,
              variants: step.variants.filter((v) => v.id !== variantId),
            }
          : step
      )
    );
  };

  const updateVariantField = (stepId, variantId, field, value) => {
    setSteps((prevSteps) =>
      prevSteps.map((step) =>
        step.id === stepId
          ? {
              ...step,
              variants: step.variants.map((v) =>
                v.id === variantId ? { ...v, [field]: value } : v
              ),
            }
          : step
      )
    );
  };
  const handleupdateEmailTemplateData = (value, field = "subject") => {
    const latestData = steps[steps.length - 1];
    const lastVariantId = latestData?.variants[latestData?.variants.length - 1];
    updateVariantField(latestData.id, lastVariantId.id, field, value);
  };
  const handleSave = () => {
    for (let step of steps) {
      for (let variant of step.variants) {
        if (!variant.subject.trim() || !variant.body.trim()) {
          showToast("Subject and Body cannot be empty", "error");
          return;
        }
      }
    }
    const payload = { steps };
    dispatch(successCreateInstantlyCampaign(payload));
    // navigate("/ats/campaigns/add-campaign#schedule")
    navigate("/ats/campaigns/add-campaign?add-campaign=schedule");
  };
   useEffect(() => {
    if (createCampaigns && Object.keys(createCampaigns).length > 0) {
      if((createCampaigns?.steps||[]).length>0){
      setSteps(createCampaigns?.steps||[])
      }
    }
  }, [createCampaigns]);

  return (
    <div className="flex gap-5 mx-4 my-3 px-2 py-4 items-start">
      <div className="w-fit">
        {steps.map((step, index) => (
          <div key={step.id} className="mb-4">
            {index > 0 && (
              <div className="mb-3">
                <FormFieldSet
                  type="text"
                  title="Send next message in days"
                  placeholder="Send next message in days"
                  value={step.delay}
                  onChange={(value) => handleDelayChange(step.id, value)}
                />
              </div>
            )}

            <div className="inner-section p-4 rounded flex flex-col gap-2">
              <div className="border-b border-gray-300 flex justify-between items-center my-2">
                <p>Step {index + 1}</p>
                <Button
                  type="icon"
                  variant="text"
                  icon={"delete"}
                  size="sm"
                  onClick={() => removeStep(step.id)}
                />
              </div>

              <div className="flex flex-col gap-2">
                {step.variants.map((variant, vIndex) => (
                  <div
                    key={variant.id}
                    className="w-full border border-gray-300 flex justify-between items-center py-1 px-2 rounded bg-white hover:border-primary-600 focus-within:border-primary-600 focus-within:outline-none"
                  >
                    <input
                      className="w-full border-0 focus:outline-none text-black bg-white"
                      placeholder="<Empty subject>"
                      value={variant.subject}
                      onChange={(e) =>
                        updateVariantField(
                          step.id,
                          variant.id,
                          "subject",
                          e.target.value
                        )
                      }
                    />
                    <>
                      <FormFieldSet
                        isChecked={variant?.v_disabled}
                        type="toggle"
                        size="xs"
                        onChange={(value) =>
                          updateVariantField(
                            step.id,
                            variant.id,
                            "v_disabled",
                            value
                          )
                        }
                        noTitle
                      />
                      {vIndex !== 0 && (
                        <Button
                          type="icon"
                          icon={"delete"}
                          variant="text"
                          color="black"
                          onClick={() => onDeleteVariant(step.id, variant.id)}
                        />
                      )}
                    </>
                  </div>
                ))}
              </div>

              {step.variants.length < 10 && (
                <div className="grid grid-cols-2 my-2">
                  <Button
                    title={"Add Variant"}
                    icon={"add"}
                    size="sm"
                    onClick={() => addVariant(step.id)}
                  />
                </div>
              )}
            </div>

            {index === steps.length - 1 && steps.length < 5 && (
              <div className="grid grid-cols-1 gap-3 my-2">
                <Button
                  title={"Add Step"}
                  icon={"add"}
                  variant="outlined"
                  size="sm"
                  onClick={addStep}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="flex flex-col flex-1 gap-y-5">
        <FormFieldSet
          noTitle
          value={sub}
          placeholder={"Enter the Sub"}
          onChange={(value) => {
            handleupdateEmailTemplateData(value, "subject"), setSub(value);
          }}
        />
        <CkTextEditor
          onChange={(value) => {
            handleupdateEmailTemplateData(value, "body"), setBody(value);
          }}
          value={body}
        />
        <div className="flex justify-end">
          <Button
            title={"Save"}
            icon={"stat_minus_1"}
            iconPosition="after"
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  );
};

export default Sequences;
